import { LazyFactory } from 'app/core/core.types';

/**
 * Lazy entry of the global Ask panel. The only Copilot file the eagerly loaded
 * layout imports, so the Ask component, CopilotState and their dependencies
 * stay in a separate chunk fetched on the first click.
 */
export const CopilotAskPanelFactory: LazyFactory = () => import('./copilot-ask-panel.bundle');
